import { PartialBrief } from '../../../../Types/Brief'
import { getSymbolForCurrency } from '../../../../Utilities/currencySymbol'

interface BudgetProps {
  brief: PartialBrief
}

export const Budget = ({ brief }: BudgetProps): JSX.Element => (
  <>
    {getSymbolForCurrency(brief.currency ?? undefined)} {brief.budget}
  </>
)

export default Budget
